// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '387a76f1b08c3311212c54b4aaf4df26fe11f3db';
export const BUILD_NUMBER = '215';
export const BUILD_TIMESTAMP = '2026-08-10T04:17:46.517Z';
